'use client';

import { atom } from 'jotai';

import type { Locale } from '../../Entities/Locale/Locale.entity';

export const localeAtom = atom<Locale>('uk');
